import {defineNuxtPlugin} from 'nuxt/app';
import {useFeatureFlagsStore} from '../stores/feature-flags.store';

export default defineNuxtPlugin(async () => {
    const {loadFeatureFlags} = useFeatureFlagsStore();
    await loadFeatureFlags();
});
